/**
 * Third-party integration icons
 * SVG components approximating the third-party favicons used in navigation.
 */

interface IconProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  viewBox?: string;
}

/**
 * Matches the white tile with dark roof and lime block favicon.
 */
export const DaluxIcon = ({
  className = '',
  width = 24,
  height = 24,
  viewBox = '0 0 64 64',
}: IconProps) => (
  <svg
    viewBox={viewBox}
    width={width}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
  >
    <rect width="64" height="64" rx="10" fill="#F8F8F5" />
    <path d="M3 34.5L31.8 7L61 34.5H48.6L32 18.8L15.4 34.5H3Z" fill="#556D79" />
    <rect x="12.5" y="34" width="38" height="20" fill="#97CE3D" />
  </svg>
);

/**
 * Matches the solid green angular "e" favicon.
 */
export const EforsyningIcon = ({
  className = '',
  width = 24,
  height = 24,
  viewBox = '0 0 32 32',
}: IconProps) => (
  <svg
    viewBox={viewBox}
    width={width}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
  >
    {/* Outer house */}
    <path fill="#89BE44" d="M2 10.5 16 1l14 9.5V30H2V10.5Z" />

    {/* White inner house background */}
    <path fill="#FFFFFF" d="M6 12.4 16 5.5 26 12.4V26H6V12.4Z" />

    {/* Energy / consumption line */}
    <path
      fill="none"
      stroke="#89BE44"
      strokeWidth="4"
      strokeLinecap="square"
      strokeLinejoin="miter"
      d="M6 19l6-6 5 6 5-3 4 3"
    />
  </svg>
);

/**
 * Matches the green rounded-square favicon with the white roof mark.
 */
export const DatahubIcon = ({
  className = '',
  width = 24,
  height = 24,
  viewBox = '0 0 32 32',
}: IconProps) => (
  <svg
    viewBox={viewBox}
    width={width}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
  >
    <path
      fill="#30AB82"
      d="M5.5 1 H24 Q26 1 26 3 V6 Q26 8 24 8 H12 L11 24 H23 Q25 24 25 26 V29 Q25 31 23 31 H4 L5.5 1 Z M18 13 H24 V19 H18 Z"
    />
  </svg>
);
